import React, { useState } from "react";
import { Modal, Form, InputGroup } from "react-bootstrap";
import Button from "react-bootstrap/Button";

import GetBaseUrl from "../../../functions/SetBaseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

function Blackboard(props) {
  const handleClose = () => props.setViewMode(false);
  const [selected, setSelected] = useState(props.selectedUser);

  const BaseUrl = GetBaseUrl()[0];
  var token = localStorage.getItem(GetBaseUrl()[1] + "_Edu_AuthToken");

  //---------------------------------------------------

  return (
    <Modal
      centered
      show
      onHide={handleClose}
      size="md"
      dialogClassName="custom-modal"
    >
      <Modal.Header className="p-4 pb-0 fs-7 fw-bold" closeButton>
        <h4>User Information</h4>
      </Modal.Header>
      <Modal.Body className="px-4">
        <div className="d-flex flex-column align-items-center w-100">
          <div className="w-100 row ">
            <label className="fs-7 fw-semibold"> Full Name</label>
            <Form.Control
              type="text"
              className="p-3 py-2 rounded-pill w-100 mb-4"
              placeholder="Full Name"
              defaultValue={
                selected && selected.firstName + " " + selected.lastName
              }
              readOnly
            />

            <label className="fs-7 fw-semibold"> Email Address</label>
            <Form.Control
              type="text"
              className="p-3 py-2 rounded-pill w-100 mb-4"
              placeholder="User Name"
              defaultValue={selected && selected.displayEmail}
              readOnly
            />

            <label className="fs-7 fw-semibold"> User Name</label>
            <Form.Control
              type="text"
              className="p-3 py-2 rounded-pill w-100 mb-4"
              placeholder="User Name"
              defaultValue={selected && selected.username}
              readOnly
            />

            <label className="fs-7 fw-semibold"> Mobile Number</label>
            <Form.Control
              type="text"
              className="p-3 py-2 rounded-pill w-100 mb-4"
              placeholder="User Name"
              defaultValue={selected && selected.mobile}
              readOnly
            />

            <div className="w-50">
              <label className="fs-7 fw-semibold"> Role Name</label>
              <Form.Control
                type="text"
                className="p-3 py-2 rounded-pill w-100 mb-4"
                placeholder="User Name"
                defaultValue={selected && selected.role}
                readOnly
              />
            </div>
            <div className="w-50 ">
              <label className="fs-7 fw-semibold"> Status</label>
              <Form.Control
                type="text"
                className="p-3 py-2 rounded-pill w-100 mb-4"
                placeholder="User Name"
                defaultValue={
                  selected && selected.isActive ? "Active" : "Inactive"
                }
                readOnly
              />
            </div>

            <div className="d-flex justify-content-center w-100">
              <Button
                className=" w-100 fw-semibold rounded-pill py-2 mx-2"
                variant="secondary"
                onClick={handleClose}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Blackboard;
